import React, { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import MatchLogModal from "./components/MatchLogModal";

import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import Dashboard from "./pages/Dashboard";
import MatchLogs from "./pages/MatchLogs";
import Analytics from "./pages/Analytics";
import AICoach from "./pages/AICoach";
import Profile from "./pages/Profile";
import Compare from "./pages/Compare";
import PublicProfile from "./pages/PublicProfile";

function AppShell() {
  const [modalOpen, setModalOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);
  const onMatchCreated = () => setRefreshKey((k) => k + 1);

  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ForgotPassword />} />
        <Route path="/share/:token" element={<PublicProfile />} />
        <Route
          element={
            <ProtectedRoute>
              <Layout onOpenLogModal={openModal} />
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={<Dashboard onOpenLogModal={openModal} key={refreshKey} />} />
          <Route path="/matches" element={<MatchLogs onOpenLogModal={openModal} refreshKey={refreshKey} />} />
          <Route path="/analytics" element={<Analytics key={refreshKey} />} />
          <Route path="/ai-coach" element={<AICoach />} />
          <Route path="/compare" element={<Compare />} />
          <Route path="/profile" element={<Profile />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <MatchLogModal open={modalOpen} onClose={closeModal} onCreated={onMatchCreated} />
      <Toaster position="top-right" theme="dark" richColors />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppShell />
      </AuthProvider>
    </BrowserRouter>
  );
}
